/* global $, responsiveBackground */

const $heroBg = $('.js-hero-bg');
const $heroContent = $('.js-hero-content');
const $coreBusiness = $('.js-core-business');
const $coreBusinessItem = $('.js-core-business-item');

const HERO_SIZES = ['hero_small', 'hero_medium', 'hero_large', 'hero_xlarge'];
const HERO_BREAKPOINTS = [480, 960, 1400, 1920];
const ANIMATION_TIME = 500;

const coreBusiness = {
  initialize() {
    if ($coreBusiness.length) {
      this.createEvents();
    }
  },

  createEvents() {
    let counter = 0;
    let isPaused = false;

    setInterval(() => {
      if (!isPaused) {
        $coreBusinessItem.removeClass('is-active');

        const $currentItem = $coreBusinessItem.eq(counter);
        const image = $currentItem.data('image');
        const content = $currentItem.find('.js-core-business-hero-content').html();

        if (!$currentItem.hasClass('is-active')) {
          this.changeHeroBackground(image);
          this.changeHeroContent(content);
        }

        $currentItem.addClass('is-active');

        counter += 1;

        if (counter === $coreBusinessItem.length) {
          counter = 0;
        }
      }
    }, 5000);

    $coreBusinessItem.on('mouseenter', ({ currentTarget }) => {
      const $target = $(currentTarget);
      const image = $target.data('image');
      const content = $target.find('.js-core-business-hero-content').html();

      if (!$target.hasClass('is-active')) {
        this.changeHeroBackground(image);
        this.changeHeroContent(content);
      }

      $coreBusinessItem.removeClass('is-active');
      $target.addClass('is-active');
    });

    $('.js-core-business-item, .js-hero').on('mouseenter', () => {
      isPaused = true;
    });

    $('.js-core-business-item, .js-hero').on('mouseleave', () => {
      isPaused = false;
    });
  },

  changeHeroBackground(image) {
    const arr = [];

    HERO_SIZES.forEach((size, index) => {
      arr.push(`${image.replace('hero_xlarge', size)} ${HERO_BREAKPOINTS[index]}`);
    });

    $heroBg.fadeOut(ANIMATION_TIME, () => {
      $heroBg.attr('data-bg', arr.join(','));
      responsiveBackground();
      $heroBg.fadeIn(ANIMATION_TIME);
    });
  },

  changeHeroContent(content) {
    $heroContent.fadeOut(ANIMATION_TIME, () => {
      $heroContent.html(content);
      $heroContent.fadeIn(ANIMATION_TIME);
    });
  },
};

export default coreBusiness;
